var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSaida = function SvgSaida(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlSpace: "preserve",
    width: 30.501,
    height: 30.501,
    viewBox: "0 0 8.07 8.07",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("marker", {
    id: "a",
    markerHeight: 6.8,
    markerWidth: 3.8,
    orient: "auto",
    preserveAspectRatio: "xMidYMid",
    refX: 0,
    refY: 0,
    style: {
      overflow: "visible"
    },
    viewBox: "0 0 3.8 6.8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-.225-.027c0 1.656 1.344 3 3 3v-6c-1.656 0-3 1.344-3 3z",
    style: {
      fill: "context-stroke",
      fillRule: "evenodd",
      stroke: "context-stroke",
      strokeWidth: ".6pt"
    }
  })), /*#__PURE__*/React.createElement("marker", {
    id: "b",
    markerHeight: 0.001,
    markerWidth: 0.001,
    orient: "auto",
    preserveAspectRatio: "xMidYMid",
    refX: 0,
    refY: 0,
    style: {
      overflow: "visible"
    },
    viewBox: "0 0 5.667 5.667"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 0c0 2.76-2.24 5-5 5s-5-2.24-5-5 2.3-5 5-5c2.76 0 5 2.24 5 5z",
    style: {
      fill: "context-stroke",
      fillRule: "evenodd",
      stroke: "context-stroke",
      strokeWidth: "1pt"
    },
    transform: "scale(.5)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M7.952 4.035a3.917 3.917 0 0 1-3.917 3.916A3.917 3.917 0 0 1 .118 4.035 3.917 3.917 0 0 1 4.035.118a3.917 3.917 0 0 1 3.917 3.917Z",
    style: {
      fill: "green",
      fillRule: "evenodd",
      stroke: "green",
      strokeWidth: 0.206879,
      strokeLinecap: "square",
      strokeMiterlimit: 3.1,
      paintOrder: "markers fill stroke"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.24 -.146)scale(1.16188)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.049 4.095v1.423a.03.03 0 0 1-.007.019.03.03 0 0 1-.019.008H1.748a.026.026 0 0 1-.027-.027V1.684c0-.015.012-.027.027-.027v0h3.274c.015 0 .026.012.026.027v.958",
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "#fff",
      strokeWidth: 0.467593,
      strokeLinecap: "round",
      strokeMiterlimit: 3.1,
      strokeOpacity: 1,
      paintOrder: "markers fill stroke"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.527 3.36h2.039",
    style: {
      fill: "#fff",
      stroke: "#fff",
      strokeWidth: 0.0670107,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 0,
      strokeDasharray: "none",
      strokeOpacity: 1,
      markerStart: "url(#a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.682 2.649.659.711-.65.732v0",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 0.425887,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeOpacity: 1,
      markerMid: "url(#b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.718 3.13h1.526v.456H4.718Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 0.133102,
      strokeLinecap: "round",
      strokeMiterlimit: 0,
      strokeDasharray: "none",
      paintOrder: "markers fill stroke"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.324 3.347H5.058",
    style: {
      fill: "#fff",
      stroke: "#fff",
      strokeWidth: 0.0554579,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 0,
      strokeDasharray: "none",
      strokeOpacity: 1,
      markerStart: "url(#a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.153 3.171h-1.12v.35h1.12z",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "#fff",
      strokeWidth: 0.0997121,
      strokeLinecap: "round",
      strokeMiterlimit: 0,
      strokeDasharray: "none",
      paintOrder: "markers fill stroke"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.567,
    height: 4.243,
    x: 1.572,
    y: 1.085,
    rx: 0.237,
    ry: 0.237,
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "#fff",
      strokeWidth: 0.0647448,
      strokeLinecap: "round",
      strokeMiterlimit: 0,
      strokeDasharray: "none",
      paintOrder: "markers fill stroke"
    },
    transform: "scale(.97221 1)skewY(13.176)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.993 3.71 1.501 1.104v.076l-.166-.115-1.335-.317Zm0-.162 1.501 1.104v.081l-1.5-1.104zm0-.169 1.501 1.11v.082l-1.5-1.11Zm0-.161 1.501 1.109v.08L1.994 3.3Zm0-.157 1.501 1.104v.08l-1.5-1.108Zm0-.164.714.527v-.358l.787.187v.827l-1.5-1.102Z",
    "aria-label": "N",
    style: {
      fontWeight: 700,
      fontSize: "53.3333px",
      lineHeight: 0.65,
      fontFamily: "Sinaloa-Normal",
      InkscapeFontSpecification: "&quot",
      textAlign: "center",
      letterSpacing: 0,
      wordSpacing: 0,
      whiteSpace: "pre",
      fill: "green",
      strokeWidth: 0.0433
    }
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSaida, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/saida.eb5065fb.svg";
export { ForwardRef as ReactComponent };